import classNames from "classnames";
import { FC } from "react";
import styles from "./styles.module.scss";

type Props = {
  className?: string;
  active: number;
  total: number;
};

const Level: FC<Props> = ({ active, total, className }) => {
  return (
    <div className={classNames(styles.level, className)}>
      <div className={styles.content}>
        {active}/{total}
      </div>
    </div>
  );
};

export default Level;
